import ViewEditSlotModal from './ViewEditSlotModal';

export default ViewEditSlotModal;
